/* eslint-disable react-hooks/exhaustive-deps */
import classNames from 'classnames';
import useCustomToast from 'hooks/useCustomToasts';
import moment from 'moment';
import normalizeText from 'normalize-text';
import React, { useEffect, useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { getQueryParams } from 'utils/funciones';
import Seccion from './components/Seccion';
import ShowOnSeccionWrapper from './components/ShowOnSeccionWrapper';
import { useDynamicForm } from './state';
import './styles/index.scss';
import './typedefs';

export const validarFechasMinMaxFixed = ({ min, max, fixed, valueMoment, msgMin, msgMax, msgFixed, msgMinMax }) => {
  if (min && max) {
    const fechaMin = moment().subtract(min.value, min.unit);
    const fechaMax = moment().subtract(max.value, max.unit);
    const isValidMin = valueMoment.isBefore(fechaMin);
    const isValidMax = valueMoment.isAfter(fechaMax);

    if (isValidMin && isValidMax) {
      return true;
    }
    return msgMinMax?.(fechaMin, fechaMax);
  }

  if (min) {
    const fecha = moment().subtract(min.value, min.unit);
    const isValid = valueMoment.isBefore(fecha);
    if (!isValid) {
      return msgMin?.(fecha);
    }
  }
  if (max) {
    const date = moment(max?.value, 'yyyy-MM-DD');
    if (typeof max?.value === 'string' && !max.unit && date.isValid()) {
      const isValidBefore = valueMoment.isBefore(date);
      const isValidSame = valueMoment.isBefore(date);
      if (isValidBefore || isValidSame) {
        return true;
      }
      return msgMax?.(date);
    }
    const fecha = moment().subtract(max.value, max.unit);
    const isValid = valueMoment.isAfter(fecha);
    if (!isValid) {
      return msgMax?.(fecha);
    }
  }
  if (fixed) {
    const leadMoment = moment().subtract(fixed.value, 'years');
    const anioActual = moment().diff(leadMoment, 'years', true);
    const anioReact = moment().diff(valueMoment, 'years', true);
    const isValid = Math.floor(anioActual) === Math.floor(anioReact);

    if (isValid) {
      return true;
    }
    return msgFixed?.();
  }

  return true;
};

/**
 *
 * @param {import('./typedefs').Formulario & {resources:any}} props
 */
const DynamicForm = ({
  subtitulo = '',
  titulo = '',
  resources = {},
  secciones: seccionesForm,
  containerFormColsClassNames = 'col-11 col-md-11',
  containerFormPadMarClassNames = 'mb-5 px-2',
  containerFormClassName = 'dynamic__form__container ',
  ...rest
}) => {
  const { secciones, setSecciones, setFieldState } = useDynamicForm();
  const methods = useFormContext();
  const toast = useCustomToast();
  const { dataUsuario } = useSelector((state) => state.datosUsuarios);
  const [isReloading, setIsReloading] = useState(false);

  useEffect(() => {
    const normalizeObject = (object) => {
      return normalizeText(JSON.stringify(object));
    };
    const objectIncludes = (object, keyword) => {
      return normalizeObject(object || {}).includes(keyword);
    };

    const isFisica = () => {
      return objectIncludes(methods.watch('tipoPersona'), 'fisica');
    };
    const isMoral = () => {
      return objectIncludes(methods.watch('tipoPersona'), 'moral');
    };

    const isFisicaOrMoral = () => isFisica() || isMoral();

    const isDTC = () => {
      return !dataUsuario?.userIsLoggedIn || dataUsuario.usu_tipo_usuario === 'cliente';
    };

    const isAgente = () => {
      return dataUsuario?.userIsLoggedIn && dataUsuario.usu_tipo_usuario === 'agente-user';
    };

    const isTest = true;
    setSecciones(seccionesForm, {
      funciones: rest?.funciones || {},
      getQueryParams,
      moment,
      normalizeText,
      normalizeObject,
      objectIncludes,
      methods,
      toast,
      isFisica,
      isMoral,
      isFisicaOrMoral,
      isTest,
      isDTC,
      isAgente,
      setIsReloading,
      validarFechasMinMaxFixed,
      setFieldState,
      isReloading,
      catalogo: resources,
    });
  }, []);

  const containerColsFormClassNames = useMemo(
    () => classNames(containerFormColsClassNames, containerFormPadMarClassNames, containerFormClassName),
    [containerFormColsClassNames, containerFormPadMarClassNames, containerFormClassName]
  );

  return (
    <React.Fragment>
      <div className="row justify-content-center mb-5 mx-1">
        <div className={containerColsFormClassNames}>
          <h2 className="dynamic__form__title">{titulo}</h2>
          {subtitulo !== '' && <b className="text-bolder font-20px text-left pl-3">{subtitulo}</b>}
          {!isReloading &&
            secciones.length > 0 &&
            secciones?.map((/** @type {import('./typedefs').Seccion} */ seccion) => {
              const component = <Seccion {...seccion} key={seccion.id} />;
              if (seccion?.showOn) {
                return (
                  <ShowOnSeccionWrapper name={seccion.codigoCore} showOn={seccion.showOn} key={seccion.id}>
                    {component}
                  </ShowOnSeccionWrapper>
                );
              }
              return component;
            })}
        </div>
        <br />
      </div>
    </React.Fragment>
  );
};

export default DynamicForm;
